import { createFileRoute } from "@tanstack/react-router";
import { TabOne } from "@/views/showcase/tabs/TabOne.tsx";
import { Link, Tab } from "@mui/material";
import type { ReactNode } from "react";
import { TabContext, TabPanel } from "@mui/lab";
import { AppTabList } from "@/components/AppTabList";

export type TabType = {
  label: string;
  value: string;
  href: string;
  children: ReactNode;
};

export const Route = createFileRoute("/_dashboard/showcase/tabs/$tab")({
  component: TabsShowcase,
});

function TabsShowcase() {
  const TABS: TabType[] = [
    {
      label: "One item",
      href: "one",
      value: "one",
      children: (
        <>
          <TabOne />
        </>
      ),
    },
    {
      label: "Two item",
      href: "two",
      value: "two",
      children: (
        <>
          <TabOne />
        </>
      ),
    },
  ];
  const { tab } = Route.useParams();

  return (
    <TabContext value={tab}>
      <AppTabList>
        {TABS.map((tab) => (
          <Tab
            key={tab.value}
            label={tab.label}
            value={tab.value}
            component={Link}
            href={tab.href}
          />
        ))}
      </AppTabList>
      {TABS.map((tab) => (
        <TabPanel value={tab.value} key={tab.value}>
          {tab.children}
        </TabPanel>
      ))}
    </TabContext>
  );
}
